import Axios from "axios"

const axios = Axios.create({
	baseURL: process.env.REACT_APP_API_ROOT + "/admin/enewspaper/",
})

const enewspaperApi = {
	_errorMsg: "",

	_post: async function (path, body, options = {}) {
		return this._axios(path, "post", body, options)
	},

	_get: async function (path, options = {}) {
		return this._axios(path, "get", null, options)
	},

	_delete: async function (path, body, options = {}) {
		return this._axios(path, "delete", body, options)
	},

	_axios: async function (path, method, body = null, options = {}) {
		const { signal, params, responseType, headers } = options

		const axiosOptions = {
			method,
			url: path,
			data: body,
			withCredentials: true,
			signal,
			params,
			responseType,
			headers,
		}

		try {
			const { data } = await axios(axiosOptions)

			if (data && typeof data === "object" && !Array.isArray(data) && Object.prototype.hasOwnProperty.call(data, "status")) {
				if (data.status === 200) {
					return Object.prototype.hasOwnProperty.call(data, "data") ? data.data : data
				}

				console.log(`[EnewpaperError] ${path}: ${data.message}`)
				this._errorMsg = data.message
				return false
			}

			if (data && typeof data === "object" && !Array.isArray(data) && Object.prototype.hasOwnProperty.call(data, "data")) {
				return data.data
			}

			return data
		} catch (e) {
			if (e.name === "CanceledError" || e.name === "AbortError") {
				console.log(`[Enewpaper Canceled] ${path}`)
			} else {
				console.log(`[Enewpaper Error] ${path}: ${e.message}`)
			}
			this._errorMsg = e.message
			return false
		}
	},

	getUserMapCustomerList: async function (body, options = {}) {
		return this._post(`/user/list`, body, options)
	},

	getCustomerList: async function (body, options = {}) {
		return this._post(`/customer/list`, body, options)
	},

	getScheduleList: async function (id, options = {}) {
		return this._get(`/customer/${id}/schedule-charge`, options)
	},

	getPlanList: async function (options = {}) {
		return this._get(`/plan/all`, options)
	},

	getCustomer: async function (id, options = {}) {
		return this._get(`/customer/${id}`, options)
	},

	getPayments: async function (customerId, options = {}) {
		return this._get(`/customer/${customerId}/payments`, options)
	},

	getPaymentMethods: async function (userId, options = {}) {
		return this._get(`/customer/${userId}/payment-methods`, options)
	},

	getEmailLogs: async (customerId, options = {}) => {
		return enewspaperApi._get(`/customer/${customerId}/email-logs`, options)
	},

	getOtpLogs: async (customerId, options = {}) => {
		return enewspaperApi._get(`/customer/${customerId}/otp-logs`, options)
	},

	getUserLogs: async (userId, options = {}) => {
		return enewspaperApi._get(`/customer/${userId}/user-logs`, options)
	},

	getNotifications: async (customerId, options = {}) => {
		return enewspaperApi._get(`/customer/${customerId}/noti-logs`, options)
	},

	deleteCustomer: async function (customerId, options = {}) {
		return this._delete(`/customer/${customerId}`, null, options)
	},

	deleteMember: async function (memberId, options = {}) {
		return this._delete(`/customer/member/${memberId}`, null, options)
	},

	debugLogin: async function (body, options = {}) {
		return this._post(`/member/debug/login`, body, options)
	},

	subscribeCustomerToPlan: async function (planId, body, options = {}) {
		return this._post(`/customer/subscription/${planId}`, body, options)
	},

	updateExpiredPlan: async function (customerId, options = {}) {
		return this._post(`/customer/${customerId}/plan-expired`, {}, options)
	},

	getPaymentTransactions: async function (params = {}, options = {}) {
		return this._get(`/report/payment-transactions`, { ...options, params })
	},

	exportPaymentTransactions: async function (params = {}, options = {}) {
		const exportParams = { ...params, format: params.format || "csv" }
		return this._get(`/report/payment-transactions`, {
			...options,
			params: exportParams,
			responseType: "blob",
			headers: {
				Accept: "text/csv",
				...(options.headers || {}),
			},
		})
	},

	getCancelReasons: async function (params = {}, options = {}) {
		return this._get(`/customer/cancel-reasons`, { ...options, params })
	},
}

export default enewspaperApi
